<div class="parent-div">

    <div class="main">
    <h2 class="gradient-text">Let’s start with your car make</h2>
    <p class="subtitle">Choose your vehicle make to get started with our premium services</p>
    </div>

    <div class="container">
    <!-- Tabs -->
    <div class="tabs">
        <div class="tab active">Make</div>
        <div class="tab" >Model</div>
        <div class="tab">Year</div>
        <div class="tab">Variant</div>
    </div>

    <!-- Search -->
    <div class="search-box">
        <mat-icon class="material-icons">search</mat-icon>
        <input type="text" [(ngModel)]="searchText" placeholder="Search for your car make">
        <mat-icon class="material-icons" (click)="clearSearch()">close</mat-icon>
    </div>

    <!-- Grid -->
    <div class="grid">
      <div class="grid-item"
     *ngFor="let make of filteredMakes"
     (click)="selectMake(make)">  <!-- use selectMake -->
  <div class="outer-box">
    <div class="inner-box">{{ make.displayTitle.charAt(0) }}</div>
  </div>
  <span>{{ make.displayTitle }}</span>
</div>

    </div>

    
    </div>

    <!-- Footer -->
    <div class="footer">
      <div class="need-help"> Need help finding your car?</div> <a href="#">Contact our support team</a>
    </div>
</div>
